import { createContext, useContext } from "react";

import type { Button } from "~/providers/button-provider";

interface ButtonContext {
  buttons: Button[];
}

export const ButtonContext = createContext<ButtonContext | undefined>(
  undefined,
);

export const useButton = () => {
  const context = useContext(ButtonContext);

  if (context === undefined) {
    throw new Error(
      "useButton must be used within a ButtonProvider, but no provider was found",
    );
  }

  return context;
};
